// If a page-internal link to a glossary item is clicked,
// then open its accordion.

document.querySelectorAll('a[href^="#glossary_"]').forEach((anchor) => {
  anchor.addEventListener('click', () => {
    document.querySelectorAll(anchor.getAttribute('href')).forEach((glossaryItem) => {
      if (glossaryItem.getAttribute('data-collapse-item') !== 'expanded') {
        glossaryItem.querySelector('a').click();
      }
    });
  });
});
